import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';

const { space8, space16 } = ContentSpacing;

export const SubscribeWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${space8};
    align-self: stretch;
`;

export const StyledSubscribeLabel = styled.label`
    display: flex;
    align-items: center;
    gap: ${space16};
    align-self: stretch;
    cursor: pointer;
`;

export const StyledCheckbox = styled.input`
    width: 24px;
    height: 24px;
`;
